<template>
  <div class="chinaEuropeTrain">
    <Header :typeHeader="'defaultHeader'">
      <!-- banner -->
      <img slot="headerImage" :src="imgList.bannerImg" alt="">
      <!-- 标题 -->
      <div slot="headerTitle">{{ $store.state.navShow == true ? '境外承运' : 'Overseas transportation' }}</div>
      <div style="font-size: 1.125rem; color: #FFFFFF; font-weight: 100; margin-top: 0.6rem;" slot="headerTitle"> {{
        $store.state.navShow == true ? '优势价格与高时效兼具' : 'combining advantageous prices and high timeliness' }} </div>
    </Header>
    <div class="TopTitle" data-aos="fade-up">
      <div class="">
        <!-- {{this.$route.name}} --> {{ $store.state.navShow == true ? $route.name : $route.meta.EnName }}
      </div>
    </div>
    <div class="ContentIntroduceList">
      <div class="ContentIntroduce"
        v-for="(item, index) in $store.state.navShow == true ? oceanShippingList : oceanShippingListE" :key="index"
        data-aos="fade-down">
        <div class="ContentIntroduceImg">
          <img :class="'ContentIntroduceImg' + index" :src="item.icon">
        </div>
        <div class="ContentIntroduceText"> {{ item.items_content1 }} </div>
      </div>
      <div class="ContentImage" data-aos="fade-down">
        <img :src="$store.state.navShow == true ? imgList.topImg : imgList.topImgE">
      </div>
    </div>

  </div>
</template>
<script>
  /**
   * Created by www.xingnuocn.com
   * @title：境外承运
   * @author: 刘嘉鑫 
   * @version  V1.0 
   * @datecreate: 2023-08-18 14:37
   */
  import Header from "@/components/header.vue";
  export default {
    components: {
      Header,
    },
    data() {
      return {
        imgList: {
          bannerImg: require('@/assets/chinaAndRussia/CR_oceanShippingbanner.jpg'),
          // backgroundImg: require('@/assets/chinaAndRussia/backgroundImg.png'),
          aircraft: require('@/assets/chinaAndRussia/aircraft.png'),
          bottonImg: require('@/assets/chinaAndRussia/CR_oceanShippingbotton.png'),

          topImg: require('@/assets/chinaAndRussia/CR_overseasServiceProvider/top.jpg'),
          topImgE: require('@/assets/chinaAndRussia/CR_overseasServiceProvider/topE.jpg'),
        },
        oceanShippingList: [{
            icon: require('@/assets/jingwaichengyun/jwcy1.png'),
            title: '优势价格，降低运输成本。',
            items_content1: 'MG集团与哈铁、俄铁直接合作，重点发展境外承运业务，共同打造阿拉山口、霍尔果斯到俄罗斯的运输线路，并取得了具有市场优势的运输价格。2023年顺利发行二连浩特及满洲里口岸，境外承运班列发运量达105列/月。'
          },
          {
            icon: require('@/assets/jingwaichengyun/jwcy2.png'),
            title: '时效高，口岸换装优先受理。',
            items_content1: 'MG集团在中哈边境口岸（阿拉山口、霍尔果斯）拥有合作堆场，为班列提供优先受理服务。自营10000个车板，可实现在边境口岸高效换装，这都为打造“高运力、高时效”的服务质量提供坚实保障。'
          },
          {
            icon: require('@/assets/jingwaichengyun/jwcy3.png'),
            title: '经验丰富，高效性问题方案解决能力强。',
            items_content1: 'MG集团与莫斯科各场站有密切深入的合作关系，专业运营团队在解决目的站接车、拥堵、口岸等问题方面提出的解决方案切实提高了时效问题，具备很强的协议能力。'
          }
        ],
        oceanShippingListE: [{
            icon: require('@/assets/jingwaichengyun/jwcy1.png'),
            title: 'Advantageous prices and lower transportation costs.',
            items_content1: 'MG Group cooperates directly with Kha Railway and Russian Railway, focusing on the development of offshore carrier business, and jointly builds transportation routes from Alashankou and Khorgos to Russia, and obtains transportation prices with market advantages. In 2023, Erenhot and Manzhouli ports were successfully launched, with a shipment volume of 105 overseas freight trains per month.'
          },
          {
            icon: require('@/assets/jingwaichengyun/jwcy2.png'),
            title: 'Highly time-sensitive, with priority processing for port changeover.',
            items_content1: 'MG Group owns cooperative yards at Harbin border ports (Alashankou and Khorgos), which provide priority service for the freight train. MG Group has 10,000 self-managed vehicle boards, which can be efficiently loaded and unloaded at the border ports, all of which provide a solid guarantee for the service quality of "high capacity and high time efficiency".'
          },
          {
            icon: require('@/assets/jingwaichengyun/jwcy3.png'),
            title: 'Experienced and highly efficient problem-solving skills.',
            items_content1: 'MG Group has a close and intensive cooperation with Moscow terminals. The solutions proposed by our professional operations team in solving the problems of pick-ups, congestion and crossings at the destination stations effectively improve the timeliness issues and have a strong protocol capacity.'
          }
        ]
      };
    },
    mounted() {},
    methods: {},
  };
</script>
<style lang='less' scoped>
  .TopTitle {
    width: 92%;
    height: 4.95rem;
    position: relative;
    margin: 0 4%;
    top: -3.2rem;
    border-bottom: 1px solid rgba(204, 204, 204, .5);

    &>div {
      position: absolute;
      top: 1.25rem;
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;
      padding: 1.2rem 3.375rem 1.2rem 0.75rem;
      background: #2e67b1 linear-gradient(270deg, rgba(3, 0, 0, .15), hsla(0, 0%, 100%, .15));
    }
  }

  .ContentText {
    width: 92%;
    margin: 0 4%;
    // background-color: #000066;
    margin-top: -1.575rem;
    text-align: left;

    &>p {
      font-size: 0.875rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      text-indent: 2em;
      margin-bottom: 1.25rem;
      text-align: justify;
    }
  }

  .ContentIntroduceList {
    width: 92%;
    margin: 0 4% 2.4rem;

    .ContentIntroduce:last-child {
      margin-bottom: 0;
    }

    .ContentIntroduce {
      width: 100%;
      margin-bottom: 2.4rem;

      .ContentIntroduceImg {
        background: linear-gradient(360deg, rgba(46, 103, 177, 0.1) 0%, rgba(46, 103, 177, 0) 100%) !important;
        width: 100%;

        image {
          width: 100%;
          height: 100%;
        }

        .ContentIntroduceImg0 {
          width: 16rem;
          height: 8rem;
        }

        .ContentIntroduceImg1 {
          width: 11.4667rem;
          height: 10.6667rem;
        }

        .ContentIntroduceImg2 {
          width: 11.4667rem;
          height: 9.6rem;
        }
      }

      .ContentIntroduceText {
        background-color: rgba(45, 106, 171, 1);
        display: flex;
        padding: 1.25rem .7rem;
        justify-content: space-between;
        align-items: center;
        // white-space:nowrap;
        font-size: .9025rem;
        font-size: 0.7rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 1.65rem;
      }
    }
  }

  .ContentImage {
    width: 100%;
    height: 7.5rem;

    img {
      width: 100%;
      height: 100%;
    }
  }
</style>